import React, { useState, useCallback } from 'react';
import LaddaButton, { XL, SLIDE_UP } from 'react-ladda';
import PropTypes from 'prop-types';

import * as Helpers from '../helpers';
import { Input } from '../components';

const Signin = props => {
  const { signin, history, account: { loading } } = props;
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({
    password: '',
    username: '',
  });
  const changeUsername = e => setUsername(e.target.value);
  const changePassword = e => setPassword(e.target.value);
  const changeError = type => err => setErrors({ ...errors, [type]: err });
  const submit = useCallback(() => {
    const errorText = Object.values(errors).join('\n').replace(/^\s+|\s+$/g, '');
    if (!errorText) {
      signin(username, password, history);
    } else {
      Helpers.notification.error(errorText || 'Fill in the form appropraitely.');
    }
  }, [signin, username, password, history, errors]);
  const showLoader = loading.some(url => url === 'signin');
  return (
    <div id="background">
      <div className="back" onClick={history.goBack}>Back</div>
      <div>
        <Input
          className="input"
          type="text"
          placeholder="Username"
          value={username}
          onChange={changeUsername}
          onError={changeError('username')}
        />
      </div>
      <div>
        <Input
          className="input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={changePassword}
          validate={false}
        />
      </div>
      <div>
        <LaddaButton
          className="button"
          loading={showLoader}
          onClick={submit}
          data-color="#000000"
          data-size={XL}
          data-style={SLIDE_UP}
          data-spinner-size={30}
          data-spinner-color="#000000"
          data-spinner-lines={6}
        >
          {showLoader ? '' : 'Sign in'}
        </LaddaButton>
      </div>
    </div>
  );
};

Signin.propTypes = {
  account: PropTypes.shape({
    loading: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  signin: PropTypes.func.isRequired,
};

export default Signin;
